import React from 'react';
import { BsInstagram } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';
const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div>
          <a href='https://www.instagram.com/_wass.im/' target='_blank'><BsInstagram/></a>
        </div>
        <div>
          <a href='https://www.facebook.com/profile.php?id=100007653377466' target='_blank'><FaFacebookF/></a>
        </div>
    </div>
  )
}

export default SocialMedia